import { render, staticRenderFns } from "./BaseTeacherListFacultyInformation.vue?vue&type=template&id=1a52c39a&scoped=true"
import script from "./BaseTeacherListFacultyInformation.vue?vue&type=script&lang=js"
export * from "./BaseTeacherListFacultyInformation.vue?vue&type=script&lang=js"
import style0 from "./BaseTeacherListFacultyInformation.vue?vue&type=style&index=0&id=1a52c39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52c39a",
  null
  
)

export default component.exports